<template>
  <v-row>
    <v-col md="12">
      <v-data-table
        height="300"
        v-model="selected"
        :headers="headers"
        :items="listaAfiliado()"
        :items-per-page="15"
        item-key="id_solic"
        class="elevation-1"
        single-select
        selectable-key="id_solic"
        show-select
      >
        <template v-slot:item.Estados.descripcion_estado="{ item }">
          <v-chip :color="getColor(item.Estados.id_estado)" dark>{{
            item.Estados.descripcion_estado
          }}</v-chip>
        </template>
        <template v-slot:item.TomadaPor="{ item }">
          <usuario :id_usuario="item.id_usuario"></usuario>
        </template>
      </v-data-table>
    </v-col>
    <v-col md="12">
      <Practica v-if="selected" readonly :solic="selected[0]"></Practica>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Practica from "@/components/Practica/Practica";
import usuario from "@/components/Usuarios/TraerNombre";
import LUM from "@/lib/LUM";
export default {
  components: {
    Practica,
    usuario,
  },
  props: ["id_afiliado"],
  created() {
    this.$msjpusher.$on("practica-guardada", this.practicaguardada);
  },
  data() {
    return {
      selected: undefined,
      headers: [
        { text: "Nro.Solic", value: "id_solic" },
        { text: "fecha", value: "fecha" },
        { text: "Practica", value: "baso001.des_nom" },
        { text: "Area", value: "Areas.descripcion_area" },
        { text: "Estado", value: "Estados.descripcion_estado" },
        { text: "Prestador", value: "Efector.nombreefector" },
        { text: "TomadaPor", value: "TomadaPor" },
      ],
    };
  },
  computed: {
    ...mapState("autorizaciones", ["ListaPorAfiliado"]),
    ...mapState("areas", { listaareas: "Lista" }),
  },
  methods: {
    ...mapActions("autorizaciones", ["traerPorAfiliado"]),
    listaAfiliado() {
      let ret = [];
      if (this.ListaPorAfiliado) {
        let lst = [...this.ListaPorAfiliado];
        lst.sort(LUM.dynamicSort("-id_solic"));
        ret = lst;
      }
      return ret;
    },
    practicaguardada(datos) {
      let autoriz = this.ListaPorAfiliado.find(
        (x) => x.id_solic === datos.id_solic
      );
      if (autoriz) {
        this.traerPorAfiliado(this.id_afiliado);
      }
    },
    getColor(id_estado) {
      let ret = "lime lighten-4";
      switch (id_estado) {
        case 1:
          ret = "red";
          break;
        case 2:
          ret = "green";
          break;
        case 3:
          ret = "blue";
          break;
        case 4:
          ret = "black";
          break;
        case 5:
          ret = "white";
          break;
        default:
          break;
      }
      return ret;
    },
  },
  mounted() {
    this.traerPorAfiliado(this.id_afiliado);
  },
  watch: {
    id_afiliado() {
      this.traerPorAfiliado(this.id_afiliado);
    },
  },
};
</script>
